// extracted by mini-css-extract-plugin
module.exports = {"container":"OutOfStockFilter_container__z4OeY","label":"OutOfStockFilter_label__33we8"};